import { type ImportData, type ImportGetInput, type ImportGetSuccess, type ImportId } from '@terros/common'
import { type TinyQueryOptions, useTantalimQuery } from '../query'
import { importKey } from '../keys'
import { type GetHookResponse } from '../hooks'

export function useImport(importId: ImportId, options?: TinyQueryOptions): GetHookResponse<ImportData> {
  return useTantalimQuery<ImportGetInput, ImportGetSuccess, ImportData>({
    url: '/import/get',
    queryKey: importKey(importId),
    input: { importId },
    convertResponse: (data) => data.log,
    options,
  })
}
